const getBaseLayered = async ({ client , controller , attributesMethod , pricesMethod , searchTerm , where  })=>{
    const [layeredData, layeredPricesData] = await Promise.all([
        attributesMethod({
            client,
            controller,
            searchTerm,
            where
        }),
        pricesMethod({
            client,
            controller,
            searchTerm,
            where
        })
    ]);
    const baseLayered = [
        ...layeredData?.data ?? [],
        ...layeredPricesData?.data ?? []
    ];
    return baseLayered;
};
const getActiveFiltersByWhere = (where)=>where?.and?.filter((condition)=>condition?.or?.length > 0).map((condition)=>Object.keys(condition.or[0])).flat().map((filter)=>filter === 'pricing.final_price' ? 'price' : filter.split('.')[1]) ?? [];
const getPromisesLayered = ({ activeFilters , baseLayered , client , controller , searchTerm , where , attributesMethod , pricesMethod  })=>{
    const promisesLayered = [];
    // loop all possible filter and for each one prepare the query
    if (activeFilters.length > 0) {
        for (const baseFilter of baseLayered){
            if (activeFilters.includes(baseFilter.id)) {
                if (baseFilter.id === 'price') {
                    const filteredWhere = {
                        and: where.and.filter((condition)=>!condition?.or?.find((filter)=>filter['pricing.final_price']))
                    };
                    promisesLayered.push({
                        filterId: baseFilter.id,
                        promise: pricesMethod({
                            client,
                            controller,
                            searchTerm,
                            where: filteredWhere
                        })
                    });
                } else {
                    const filteredWhere = {
                        and: where.and.filter((condition)=>!condition?.or?.find((filter)=>filter[`filters.${baseFilter.id}.value`]))
                    };
                    promisesLayered.push({
                        filterId: baseFilter.id,
                        promise: attributesMethod({
                            client,
                            controller,
                            searchTerm,
                            where: filteredWhere
                        })
                    });
                }
            }
        }
    }
    return promisesLayered;
};
const getActiveFiltersLayered = async (promisesLayered)=>await Promise.all(promisesLayered.map(({ promise  })=>promise));
const getFinalLayered = ({ baseLayered , activeFiltersLayered , promisesLayered  })=>baseLayered.map((item)=>activeFiltersLayered[promisesLayered.findIndex(({ filterId  })=>item.id === filterId)]?.data?.find(({ id  })=>item.id === id) ?? item);

export { getActiveFiltersByWhere, getActiveFiltersLayered, getBaseLayered, getFinalLayered, getPromisesLayered };
